export const CART_OVERLAY_POPUP_ID = 'CART_OVERLAY_POPUP_ID';
